// @ts-strict-ignore
import I18n from 'APP/I18n'
import Alert from 'APP/Converse/Alert'

type AlertButton = {
  text: string
  onPress?: () => void
}

export function handleRetryableRequestFailure(failureBody: string) {
  return new Promise((resolve) => {
    setTimeout(() => {
      Alert.alert(I18n.t('error.alert.title'), failureBody, [
        { text: I18n.t('error.alert.cancel'), onPress: () => resolve(false) },
        { text: I18n.t('error.alert.tryAgain'), onPress: () => resolve(true) },
      ])
    }, 100)
  })
}

export function handleNonRetryableRequestFailure(
  failureBody: string,
  failureTitle: string = I18n.t('error.alert.title'),
  customButtons: AlertButton[] | undefined = undefined
) {
  return new Promise((resolve) => {
    setTimeout(() => {
      let buttons = [{ text: I18n.t('error.alert.ok'), onPress: resolve }]

      if (customButtons) {
        // The first button is overridden to include this Promise's `resolve`,
        // While it does seem weird, it's due to `resolve` is not possible to be passed down,
        // and we want to ensure that the first button allows the modal to be dismissable
        buttons = customButtons.map((button, index) => ({
          ...button,
          onPress: index === 0 ? resolve : button.onPress || resolve,
        }))
      }

      Alert.alert(failureTitle, failureBody, buttons)
    }, 100)
  })
}

export default {
  handleNonRetryableRequestFailure,
  handleRetryableRequestFailure,
}
